import { useDocumentsStore } from '../store';
import { FolderOpen } from 'lucide-react';

interface EmptyDocumentsStateProps {
  context?: string;
}

export const EmptyDocumentsState: React.FC<EmptyDocumentsStateProps> = ({
  context,
}) => {
  const { openUploadModal } = useDocumentsStore();

  return (
    <div className="rounded-xl border border-neutral-200 bg-neutral-50 p-12 text-center sm:p-16">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-neutral-100 sm:h-16 sm:w-16">
        <FolderOpen className="h-6 w-6 text-neutral-400 sm:h-8 sm:w-8" />
      </div>
      <h3 className="mb-2 text-lg font-semibold text-neutral-900">
        Aucun document
      </h3>
      <p className="mx-auto mb-6 max-w-md text-sm text-neutral-600 sm:text-base">
        {context
          ? `Aucun document n'a encore été ajouté à ${context}.`
          : "Aucun document n'a encore été ajouté."}
      </p>
      {context && (
        <button
          onClick={openUploadModal}
          className="bg-primary-600 hover:bg-primary-700 rounded-xl px-6 py-3 font-medium text-white transition-colors"
        >
          Ajouter des documents
        </button>
      )}
    </div>
  );
};
